import { vuexEventPathGenerator } from '@/utils';
export const mutationType = {
    SELECTED_SHARE_HUB_ID: 'SELECTED_SHARE_HUB_ID',
    GET_SHARE_INFO_CONFIG: 'GET_SHARE_INFO_CONFIG',
    GET_SUBSCRIBE_HUB_TOTAL_STORE_LIST: 'GET_SUBSCRIBE_HUB_TOTAL_STORE_LIST',
    SET_SUBSCRIBE_HUB_STORE_LIST: 'SET_SUBSCRIBE_HUB_STORE_LIST',
    SET_REGISTERED_SHARE_STORE_LIST: 'SET_REGISTERED_SHARE_STORE_LIST',
    SET_SUBSCRIBE_HUB_STORE_CHECKED_LIST: 'SET_SUBSCRIBE_HUB_STORE_CHECKED_LIST',
    SET_REGISTERED_SHARE_STORE_CHECKED_LIST: 'SET_REGISTERED_SHARE_STORE_CHECKED_LIST',
    SET_SUBSCRIBE_HUB_STORE_SEARCH_OPTION: 'SET_SUBSCRIBE_HUB_STORE_SEARCH_OPTION',
    SET_REGISTERED_SHARE_STORE_SEARCH_OPTION: 'SET_REGISTERED_SHARE_STORE_SEARCH_OPTION',
    RESET_SHARE_INFO_CONFIG: 'RESET_SHARE_INFO_CONFIG',
    SET_FORM_VALUE: 'SET_FORM_VALUE',
};
export const shareConfigMutationType = vuexEventPathGenerator(mutationType, 'shareManagement/shareConfig');
const mutations = {
    [mutationType.SELECTED_SHARE_HUB_ID](state, payload) {
        state.selectedShareHubId = payload;
    },
    [mutationType.GET_SHARE_INFO_CONFIG](state, shareInfo) {
        state.shareInfoConfig = shareInfo;
    },
    // 허브의 전체 상점 리스트 (필터링 없는 순수 리스트)
    [mutationType.GET_SUBSCRIBE_HUB_TOTAL_STORE_LIST](state, storeList) {
        state.totalSubscribeHubStoreList = storeList;
    },
    [mutationType.SET_SUBSCRIBE_HUB_STORE_LIST](state, storeList) {
        state.subscribeHubStoreInfo.list = storeList;
    },
    [mutationType.SET_SUBSCRIBE_HUB_STORE_CHECKED_LIST](state, checkedList) {
        state.subscribeHubStoreInfo.checkedList = checkedList;
    },
    [mutationType.SET_REGISTERED_SHARE_STORE_LIST](state, shareStoreList) {
        state.registeredShareStoreInfo.list = shareStoreList;
    },
    [mutationType.SET_REGISTERED_SHARE_STORE_CHECKED_LIST](state, checkedList) {
        state.registeredShareStoreInfo.checkedList = checkedList;
    },
    [mutationType.SET_SUBSCRIBE_HUB_STORE_SEARCH_OPTION]({ subscribeHubStoreInfo }, searchOption) {
        Object.entries(searchOption).forEach(([key, value,]) => {
            // Vue.set(subscribeHubStoreInfo.searchOption, key, value);
            subscribeHubStoreInfo.searchOption[key] = value;
        });
    },
    [mutationType.SET_REGISTERED_SHARE_STORE_SEARCH_OPTION]({ registeredShareStoreInfo }, searchOption) {
        Object.entries(searchOption).forEach(([key, value,]) => {
            // Vue.set(registeredShareStoreInfo.searchOption, key, value);
            registeredShareStoreInfo.searchOption[key] = value;
        });
    },
    [mutationType.RESET_SHARE_INFO_CONFIG](state) {
        state.selectedShareHubId = '';
        state.shareInfoConfig = null;
        state.totalSubscribeHubStoreList = [];
        state.registeredShareStoreInfo = {
            list: [],
            checkedList: [],
            searchOption: {
                field: 'storeName',
                value: '',
            },
        };
        state.subscribeHubStoreInfo = {
            list: [],
            checkedList: [],
            searchOption: {
                field: 'storeName',
                value: '',
            },
        };
    },
    [mutationType.SET_FORM_VALUE](state, [key, value,]) {
        state.formData[key] = value;
    },
};
export default mutations;
